import React, { Component } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";

class ConfirmModal extends Component {
  render() {
    const { showBrowserModal, closeModal, saveit, deactivateLoader } =
      this.props;
    return (
      <Modal lg={"medium"} show={showBrowserModal} onHide={closeModal}>
        <Modal.Header className="no-border">
          <h4 className="m-0 font-weight-bold">{"Deactivate"}</h4>
          <Button
            title={"Deactivate"}
            type="button"
            onClick={closeModal}
            className="close-btn"
            data-dismiss="modal"
          >
            <i className="nc-icon nc-simple-remove"></i>
          </Button>
        </Modal.Header>

        <Modal.Body className="modal-data-body">
          <p className="theme-color">
            {"Are you sure you want to Deactivate?"}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{ minWidth: "93px" }}
            onClick={closeModal}
            type="button"
            className="btn btn-danger btn-cancel"
          >
            No
          </Button>
          {!deactivateLoader ? (
            <Button
              onClick={saveit}
              type="button"
              className="btn btn-fill btn-info"
            >
              Yes
            </Button>
          ) : (
            <Spinner animation="border" variant="info" />
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ConfirmModal;
